var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { JabberSendMessageData } from "./jabber-send-message-data";
var JabberCustomMessageData = /** @class */ (function (_super) {
    __extends(JabberCustomMessageData, _super);
    function JabberCustomMessageData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return JabberCustomMessageData;
}(JabberSendMessageData));
export { JabberCustomMessageData };
//# sourceMappingURL=jabber-custom-message-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/jabber-dto/jabber-custom-message-data.js
// module id = 898
// module chunks = 14